import { useEffect } from 'react';
import { UserRoundCheck, UserRoundX, Settings2 } from 'lucide-react';
import { getCallStatusText } from '../../../AgentCallConsole/utils';
import { useLogging } from 'contexts/LoggingContext';
import { Button } from 'common/components';
import { CallStatuses } from 'contexts/LiveKitContext';
import styles from './AgentCallStatus.module.scss';
import { UseAgentCallConsoleReturn } from 'components/AgentCallConsole/hooks/useAgentCallConsole';

type AgentCallStatusProps = {
    callData: UseAgentCallConsoleReturn;
    setOpenAgentConsole: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AgentCallStatus = ({ callData, setOpenAgentConsole }: AgentCallStatusProps) => {
    const { info } = useLogging();
    const isCallActive =
        callData.callStatus === CallStatuses.IN_PROGRESS ||
        callData.callStatus === CallStatuses.INCOMING ||
        callData.callStatus === CallStatuses.MANUAL_CALLBACK;
    useEffect(() => {
        if (isCallActive) {
            setOpenAgentConsole(true);

            info(
                'Call console opened by incoming or manual callback call',
                { callData },
                'AgentCallStatus',
                'call_console_opened'
            );
        }
    }, [isCallActive]);

    const buttonHandler = () => {
        // Don't allow closing during active calls
        setOpenAgentConsole((prev) => isCallActive || !prev);
    };

    return (
        <div className='flex items-center gap-md'>
            {callData.agentAvailable ? (
                <div className='flex items-center gap-sm'>
                    <UserRoundCheck color='green' size={18} className='shrink-0' />{' '}
                    <span className='text-small'>{getCallStatusText(callData.callStatus)}</span>
                </div>
            ) : (
                <div className='flex items-center gap-sm'>
                    <UserRoundX color={'var(--gray-900)'} size={18} /> <span className='text-small'>Inactive</span>
                </div>
            )}

            <div className='relative'>
                <Button
                    variant='outline-secondary'
                    isRounded
                    iconOnly
                    icon={Settings2}
                    onMouseDown={(event) => {
                        event.stopPropagation();
                    }}
                    onTouchStart={(event) => {
                        event.stopPropagation();
                    }}
                    onClick={buttonHandler}
                />
                <div className={styles.callbackIndicator} />
            </div>
        </div>
    );
};
